export default {
    setFbUser(state, payload) {
        state.user.fbUser = payload;
    },
    setIsAuthenticated(state, payload) {
        state.isAuthenticated = payload;
    },
    setMessages(state, payload) {
        state.messages = payload;
    },
    setMessageTypes(state, payload) {
        state.messageTypes = payload;
    },
    setMessageGroups(state, payload) {
        state.messageGroups = payload;
    },
    setLocations(state, payload) {
        state.locations = payload;
    },
    setEmployees(state, payload) {
        state.employees = payload;
    }
};
